import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { AbstractControl, UntypedFormArray, UntypedFormGroup } from "@angular/forms";

import { combineLatest } from "rxjs";
import { first } from "rxjs/operators";

import { NoteBruger, NoteHenvendelsestype, NoteListeComponent, NoteOmraade, NoteOpgavestyringStatus } from "@e-forsyning/common/note";

import { InstallationNoteService } from "../opgave-note.service";

@Component({
    selector: "opgave-note-liste",
    templateUrl: "./opgave-note-liste.component.html",
    styleUrls: ["./opgave-note-liste.component.scss"]
})
export class OpgaveNoteListeComponent implements OnInit {
    public get formArray(): AbstractControl {
        return (this.formGroup && this.formGroup.get("noter")) || this.emptyFormArray;
    }
    private emptyFormArray = new UntypedFormArray([]);

    @Input() public formGroup: UntypedFormGroup;
    @ViewChild("notePanel") public notePanel: NoteListeComponent;

    public omraader: NoteOmraade[];
    public henvendelsestyper: NoteHenvendelsestype[];
    public opgavestyringStatusser: NoteOpgavestyringStatus[];
    public brugere: NoteBruger[];
    public defaultOmraadeId: number;

    constructor(public readonly noteService: InstallationNoteService) {}

    public ngOnInit(): void {
        this.defaultOmraadeId = this.noteService.hentDefaultOmraadeId();
        const omraader$ = this.noteService.hentOmraader();
        const henvendelsestyper$ = this.noteService.hentHenvendelsestyper();
        const opgavestyringStatusser$ = this.noteService.hentOpgavestyringStatusser();
        const brugere$ = this.noteService.hentBrugere();
        combineLatest([omraader$, henvendelsestyper$, opgavestyringStatusser$, brugere$])
            .pipe(first())
            .subscribe((data) => {
                this.omraader = data[0];
                this.henvendelsestyper = data[1];
                this.opgavestyringStatusser = data[2];
                this.brugere = data[3];
            });
    }

    public onOpret(): void {
        this.notePanel.onOpretClick();
    }
}
